import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Feature from 'marketing-website/components/modules/Feature';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';

import assets from 'marketing-website/configs/pages/features/collaboration/assets';

export default function Features() {
  return (
    <Spacing size="l" sizeM="xl" position="topBottom" type="margin">
      <Spacing size="l" position="topBottom" type="padding">
        <PageWrap>
          <Spacing size="xl" position="bottom" type="margin">
            <Spacing size="l" position="topBottom" type="margin">
              <HeadingBlock
                title="Collaboration built for scale"
                copy={
                  <span>
                    Companies globally are using Marvel to transform how their
                    teams work together throughout the design process.
                    <br />
                    <br />
                    With our design collaboration tool users share designs,
                    receive feedback and make changes in one place. Helping them
                    move faster and communicate better.
                  </span>
                }
                alignContent="center"
                alignM="center"
              />
            </Spacing>
          </Spacing>
          <Grid columns={3} size="l">
            <GridItem columnSpan={3} columnSpanM={1}>
              <Feature
                {...assets.sharedFolder}
                title="Shared folders"
                copy="Keep company projects organised for internal and external stakeholders by building folders for different teams or related projects, whatever works for you."
                maxWidth={365}
                fontWeight="semibold"
              />
            </GridItem>
            <GridItem columnSpan={3} columnSpanM={1}>
              <Feature
                {...assets.feed}
                title="Activity notifications"
                copy="See who’s working on what and get activity notifications in real-time, whether they're design changes or feedback left in comments."
                maxWidth={365}
                fontWeight="semibold"
              />
            </GridItem>
            <GridItem columnSpan={3} columnSpanM={1}>
              <Feature
                {...assets.manageTeam}
                title="User Management"
                copy="Set access and permissions to projects for everyone in your team from admin to external reviewer, ensuring you the security and control you need."
                maxWidth={365}
                fontWeight="semibold"
              />
            </GridItem>
          </Grid>
        </PageWrap>
      </Spacing>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/collaboration/UserManagementBlock.js